import { Dispatch, RefObject, SetStateAction, useEffect, useState } from "react";
import { IInputValidationItemController } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";
import React from "react";



/**
 * works for:
 * TextInput, TextAreaInput
 */
interface IProps {
  defaultValue: string | undefined;
  disabled?: boolean | undefined;
  classNameInput: string;
  classNameFrame: string;
  disabledClass: string;
  onMount?:()=> void;
}

export interface ITextInputControllerType1Return extends IInputValidationItemController {
  //states
  blur: boolean; setBlur: Dispatch<SetStateAction<boolean>>;
  focused: boolean; setFocused: Dispatch<SetStateAction<boolean>>;
  
  //refInput: IHTMLInput | null ,
  refInput: RefObject<HTMLInputElement> | undefined
  refInputArea: RefObject<HTMLTextAreaElement> | undefined
  //refInput: HTMLInputElement | null,
  //setRefInput: Dispatch<SetStateAction<HTMLInputElement | null>>,
  //setRefInput: (it: IHTMLInput | null) => void,

  setRefDiv: (it: HTMLDivElement | null) => void,
  //value: string | undefined, setValue: Dispatch<string | undefined>
  //SsetValue: (it: string | undefined)=> void,
  //render(): void
}
// export class RefTest {
//   public static refInput: IHTMLInput | null = null;

// }

export const TextInputControllerType1 = (props: IProps): ITextInputControllerType1Return  => {
  
  const tag = "TextInputControllerType1";
  //console.log(tag + " START");

  const [blur, setBlur] = useState<boolean>(false);
  const [focused, setFocused] = useState<boolean>(false);
  // useEffect(() => {
  //   console.log(tag + "focused: "+focused);
  // }, [focused]);


  //refs
  let refDiv: HTMLDivElement | null = null;
  function setRefDiv(it: HTMLDivElement | null) {
    try {
      if (it == null) return;
      refDiv = it;
      setDisabled(true);
      setDisabled(props.disabled);
    } catch (e) {}
  }

  const refInputArea = React.createRef<HTMLTextAreaElement>();
  useEffect(() => {
    //console.log(tag+ " refInput()")
    if (refInput != null && refInput != undefined) {
      focused ? refInputArea.current?.focus() : null
      setDisabled(props.disabled);
    }
  }, [refInputArea])

  const refInput = React.createRef<HTMLInputElement>();
  useEffect(() => {
    //console.log(tag+ " refInput()")
    if (refInput != null && refInput != undefined) {
      focused ? refInput.current?.focus() : null
      setDisabled(props.disabled);
    }
  }, [refInput])


  // const [refInput, setRefInput] = useState<HTMLInputElement | null>(null);
  //   useEffect(() => {
  //   try {
  //     console.log(tag+ " refInput()")
  //     if(refInput != null){
  //       (checkFocus(refInput)) ? refInput.focus() : null
  //       setDisabled(props.disabled);
  //     }
  //   }catch(e) {
  //     console.log(e)
  //   }
  // },[refInput])


  //let focused1 = checkFocus()

  // let refInput: HTMLInputElement | null = null;
  // function setRefInput(it: IHTMLInput | null) {
  //   try {
  //     // if(refInput != null) return;
  //     // if(refInput != undefined) return;
  //     // if (it == null) return;
  //     // refInput = it;
  //     //  if(refInput != null) {
  //     //   const isFocused = refInput.focus()
  //     //  } return;
     
  //      //if(refInput != undefined) return;
  //      if (it == null) return;
  //      //refInput = it;
  //      //(focused1)? refInput!!.focus():null
  //      //if(focused) refInput?.focus()
  //      //refInput(it);
      
  //     //setDisabled(true);
  //     setDisabled(props.disabled);
  //   } catch (e) {}
  // }
  //states



  //init
  useEffect(() => {
    props.onMount?props.onMount():null
    //setDisabled(props.disabled);
    //setDisabled(true)
    //console.log(tag + " => onMount");
    return () => {
      //console.log(tag + " => onUnmount");
    };
  }, []);


  useEffect(() => {
    try {
      setDisabled(props.disabled);
    } catch (e) {}
  }, [props.disabled]);


  function setDisabled(disabled: boolean = true) {
    try {
      refDiv!!.className = disabled ? props.classNameFrame + " " + props.disabledClass : props.classNameFrame;
    } catch (e) {}

    try {
      //refInput!!.disabled = disabled;
      //refInput!!.className = disabled ? props.classNameInput + " " + props.disabledClass : props.classNameInput;
      refInput!!.current!!.disabled = disabled;
      refInput!!.current!!.className = disabled ? props.classNameInput + " " + props.disabledClass : props.classNameInput;
    } catch (e) {
    }

    try {
      //refInput!!.disabled = disabled;
      //refInput!!.className = disabled ? props.classNameInput + " " + props.disabledClass : props.classNameInput;
      refInputArea!!.current!!.disabled = disabled;
      refInputArea!!.current!!.className = disabled ? props.classNameInput + " " + props.disabledClass : props.classNameInput;
    } catch (e) {
    }
  }

  //const refInput = RefTest.refInput;
  return { 
    blur, setBlur,
    focused, setFocused,
    setRefDiv,
    refInput,
    refInputArea
  };
}